// extracted by mini-css-extract-plugin
var _1 = "SettingsFormSectionContent-modulebody__Hug4g";
export { _1 as "body" }
